(function() { window.GUID_cc438efc_0a79_4b3f_beae_a85222233f6f = { getGuid: function() { return "cc438efc-0a79-4b3f-beae-a85222233f6f"; } }; })();
var saveInProgress = false;
var rHeaders = null;
var sections = [];
var cContentEdge = null;
var lastBracketHeaderMenu = null;
var urlBase = CSParameters.RUrl + "charts/";
var openingSpeed = 100;
var headerHeight = 1;
var lastScale;
function BindBracketHeaderMenu(canvasContentEdge, flowBlockId) {
    rHeaders = $('.RoundHeaders', canvasContentEdge);
    var end = rHeaders.length;
    sections = [];
    for (var i = 0; i < end; i++) {
        var section = {
            header: $('.RoundHeaders.Section' + i, canvasContentEdge),
            zone: $('.Section.Index' + i, canvasContentEdge),
            top: 0
        };
        if (section) {
            if (section.zone[0]) {
                section.top = section.zone[0].offsetTop / parseFloat(section.zone.css('font-size').replace('px', ''));
                sections.push(section);
            }
        }
    }
    cContentEdge = canvasContentEdge;
    cContentEdge.on('Moving', function (e, canvas) {
        if (lastScale != canvas.Scale) {
            lastScale = canvas.Scale;
            if (sections.length > 0) {
                headerHeight = sections[0].header.height();
            }
        }
        RefreshPosition(cContentEdge);
    });
    var getMenuPending = false;
    rHeaders.on('mousedown', '.RoundHeader', function (e) {
        e.preventDefault();
        e.stopPropagation();
    }).on('mouseup', '.RoundHeader', function (e) {
        e.preventDefault();
        var actualHeader = $(this);
        if (lastBracketHeaderMenu != null) {
            var sameHeaderClicked = false;
            sameHeaderClicked = lastBracketHeaderMenu.data('col') == actualHeader.data('col');
            lastBracketHeaderMenu.off('click');
            lastBracketHeaderMenu.slideUp(openingSpeed, function () {
                lastBracketHeaderMenu.remove();
                lastBracketHeaderMenu = null;
            });
            if (sameHeaderClicked) {
                return;
            }
        }
        if (getMenuPending) {
            return;
        }
        getMenuPending = true;
        var mainData = {
            flowBlockId: flowBlockId,
            column: actualHeader.data('col')
        };
        CompuSport.Ajax.Get(CSParameters.RUrl + "charts/GetBracketHeaderMenu/" + CSParameters.SportEventId, mainData, function (result) {
            var newBracketHeaderMenu = $(result);
            var windowWidth = CS.win.width();
            var middleH = windowWidth / 2;
            var offset = actualHeader.offset();
            //fix offset dans chrome android zoomed
            var curleft = 0;
            var curtop = 0;
            var obj = actualHeader[0];
            if (obj.offsetParent) {
                do {
                    curleft += obj.offsetLeft + jQuery.css(obj, "borderLeftWidth", true);
                    curtop += obj.offsetTop + jQuery.css(obj, "borderTopWidth", true);
                    obj = obj.offsetParent;
                } while (obj);
            }
            //layout.csstop = curtop;
            if (offset.top - curtop > 15) {
                offset.left -= CS.win.scrollLeft();
                offset.top -= CS.win.scrollTop();
            }
            var left = '';
            var right = '';
            left = offset.left + 'px';
            right = 'auto';
            var cssMenu = { left: left, right: right, top: offset.top + actualHeader[0].offsetHeight + 'px' };
            newBracketHeaderMenu.css(cssMenu);
            CS.body.append(newBracketHeaderMenu);
            newBracketHeaderMenu.slideDown(openingSpeed, function () {
                lastBracketHeaderMenu = newBracketHeaderMenu;
                lastBracketHeaderMenu.data('col', mainData.column);
                lastBracketHeaderMenu.on('click', '.BracketHeaderMenuButton', function (e) {
                    var $clickedButton = $(this);
                    if ($clickedButton.hasClass('Main') && $clickedButton.hasClass('IsSelected')) {
                        $clickedButton.removeClass('IsSelected');
                        var bracketHeaderSubMenu = lastBracketHeaderMenu.find('#BracketHeaderSubMenu');
                        bracketHeaderSubMenu.hide("slide", { direction: "left" }, openingSpeed, function () { });
                        return;
                    }
                    if ($clickedButton.hasClass('BracketLine')) {
                        ShowSubMenu(urlBase + "BracketHeaderMenuBracketLine/" + CSParameters.SportEventId, mainData, lastBracketHeaderMenu, $clickedButton);
                    }
                    else if ($clickedButton.hasClass('RankAndAward')) {
                        ShowSubOptions(urlBase + "BracketHeaderRankAndAwardOptions/" + CSParameters.SportEventId, mainData, lastBracketHeaderMenu);
                    }
                    else if ($clickedButton.hasClass('RaceTo')) {
                        ShowSubOptions(urlBase + "BracketHeaderRaceToOptions/" + CSParameters.SportEventId, mainData, lastBracketHeaderMenu);
                    }
                    else if ($clickedButton.hasClass('AutoDivisions')) {
                        ShowSubOptions(urlBase + "BracketHeaderAutoDivisionsOptions/" + CSParameters.SportEventId, mainData, lastBracketHeaderMenu);
                    }
                    else if ($clickedButton.hasClass('MatchCard')) {
                        ShowSubOptions(urlBase + "BracketHeaderMatchCardOptions/" + CSParameters.SportEventId, mainData, lastBracketHeaderMenu);
                    }
                    else if ($clickedButton.hasClass('AddLineAtLeft') || $clickedButton.hasClass('AddLineAtRight')) {
                        AddLineAtXXButtonClicked($clickedButton, lastBracketHeaderMenu, mainData);
                    }
                    else if ($clickedButton.hasClass('DeleteLeftLine') || $clickedButton.hasClass('DeleteRightLine')) {
                        DeleteLineAtXXButtonClicked($clickedButton, lastBracketHeaderMenu, mainData);
                    }
                    else if ($clickedButton.hasClass('EditLeftLine') || $clickedButton.hasClass('EditRightLine')) {
                        EditLineAtXXButtonClicked($clickedButton, lastBracketHeaderMenu, mainData);
                    }
                    else {
                        return;
                    }
                    if ($clickedButton.hasClass('Main')) {
                        lastBracketHeaderMenu.find('.Main').removeClass('IsSelected');
                        $clickedButton.addClass('IsSelected');
                    }
                }).on('click', 'button', function (e) {
                    e.preventDefault();
                    var $button = $(e.target);
                    var bracketHeaderSubMenu = lastBracketHeaderMenu.find('#BracketHeaderSubMenu');
                    if ($button.hasClass('BtnAcceptOptions')) {
                        var refreshChart = $button.data('refreshchart') == "True";
                        var form = bracketHeaderSubMenu.find('form');
                        var data = form.serialize();
                        var url = form.attr('action');
                        CallSubMenuFunction(url, data, lastBracketHeaderMenu, null, refreshChart);
                    }
                    else {
                        bracketHeaderSubMenu.hide("slide", { direction: "left" }, openingSpeed, function () { });
                        lastBracketHeaderMenu.find('.Main').removeClass('IsSelected');
                    }
                });
                getMenuPending = false;
            });
        });
    });
    RefreshPosition(cContentEdge);
}
function ShowSubMenu(url, data, container, clickedButton) {
    CompuSport.Ajax.Get(url, data, function (result) {
        var bracketHeaderSubMenu = container.find('#BracketHeaderSubMenu');
        bracketHeaderSubMenu.hide("slide", { direction: "left" }, openingSpeed, function () {
            bracketHeaderSubMenu.empty();
            bracketHeaderSubMenu.append(result);
            bracketHeaderSubMenu.show("slide", { direction: "left" }, openingSpeed, function () { });
        });
    });
}
function ShowSubOptions(url, data, container) {
    CompuSport.Ajax.Get(url, data, function (result) {
        var bracketHeaderSubMenu = container.find('#BracketHeaderSubMenu');
        bracketHeaderSubMenu.hide("slide", { direction: "left" }, openingSpeed, function () {
            bracketHeaderSubMenu.empty();
            bracketHeaderSubMenu.append(result);
            bracketHeaderSubMenu.find('.CSColorPicker').CSColorPicker();
            bracketHeaderSubMenu.find('input:checkbox').CSCheckBox();
            bracketHeaderSubMenu.show("slide", { direction: "left" }, openingSpeed, function () { });
        });
    });
}
function CallSubMenuFunction(url, data, container, callback, refreshChart = true) {
    CompuSport.Ajax.Post(url, data, function (result) {
        if (refreshChart) {
            UpdateChart(result, true);
            RefreshPosition(cContentEdge);
        }
        if (callback != null) {
            callback();
        }
    });
}
function RefreshPosition(canvasContentEdge) {
    var canvas = canvasContentEdge.data('context');
    var containerTop = canvas.CanvasContent.position().top;
    var contentTop = canvasContentEdge[0].offsetTop;
    var end = sections.length;
    var offset = -containerTop - contentTop;
    for (var i = 0; i < end; i++) {
        var section = sections[i];
        var zoneTop = containerTop + section.zone[0].offsetTop + contentTop;
        if (section.zone[0].offsetHeight + zoneTop - headerHeight < 0) {
            section.header.hide();
        }
        else if (zoneTop < 0) {
            section.header.show();
            section.header.css('top', offset);
        }
        else {
            section.header.show();
            section.header.css('top', section.top + 'em');
        }
    }
}
function AddLineAtXXButtonClicked(button, container, data) {
    if (button.hasClass('AddLineAtLeft')) {
        data.lineSide = "AtLeft";
    }
    else {
        data.lineSide = "AtRight";
    }
    CallSubMenuFunction(urlBase + "BracketHeaderAddLineAtXX/" + CSParameters.SportEventId, data, container, function () {
        ShowSubMenu(urlBase + "BracketHeaderMenuBracketLine/" + CSParameters.SportEventId, data, container);
    });
}
function DeleteLineAtXXButtonClicked(button, container, data) {
    if (button.hasClass('DeleteLeftLine')) {
        data.lineSide = "AtLeft";
    }
    else {
        data.lineSide = "AtRight";
    }
    CallSubMenuFunction(urlBase + "BracketHeaderDeleteXXLine/" + CSParameters.SportEventId, data, container, function () {
        ShowSubMenu(urlBase + "BracketHeaderMenuBracketLine/" + CSParameters.SportEventId, data, container);
    });
}
function EditLineAtXXButtonClicked(button, container, data) {
    if (button.hasClass('EditLeftLine')) {
        data.lineSide = "AtLeft";
    }
    else {
        data.lineSide = "AtRight";
    }
    ShowSubOptions(urlBase + "BracketHeaderBracketLineOptions/" + CSParameters.SportEventId, data, container);
}
//function RefreshMathTypeCorrespondingUI(useRaceTo) {
//var raceToTitle = $('#RaceToTitle');
//var raceToLabel = $('label', $('#RaceTo').parent());
//var actualTitle = '';
//if (useRaceTo) {
//    actualTitle = raceToTitle.data('nbgamestowintitle');
//    raceToLabel.html(actualTitle);
//} else {
//    actualTitle = raceToTitle.data('matchtoplay');
//    raceToLabel.html(actualTitle);
//}
//}

//# sourceMappingURL=BracketHeaderMenu.desktop.js.map
